/* eslint-disable react-hooks/exhaustive-deps */
// eslint-disable-next-line
import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import {
  // Grid,
  Typography,
  Paper,
  Stack,
  InputLabel,
  // Tooltip,
  TextField,
  TextareaAutosize,
  Box,
  Divider,
  Button,
  Snackbar,
  Alert,
  Autocomplete,
} from "@common-ui/ui";
import PropTypes from "prop-types";
import { getOrgUsers, updateWorkItem } from "../../services";
import { RunProcedure } from "../Procedure";
import { useDispatch } from "react-redux";
import { workItemsSlice } from "../../reducers/workItemsReducer";

const WorkItem = ({
  row: rowProp,
  orgID,
  mode,
  report,
  workItemStatusChange,
}) => {
  // console.log("rowProp", rowProp);
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(true);
  const [toast, setToast] = useState([]);
  const [users, setUsers] = useState([]);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      notes: rowProp?.notes || "",
      performing_user: rowProp?.performing_user
        ? { username: rowProp?.performing_user }
        : null,
    },
    validationSchema: Yup.object({
      notes: Yup.string().trim(),
      performing_user: Yup.object().nullable(),
    }),
    onSubmit: (e) => {
      async function submit() {
        let { notes, performing_user } = formik.values;
        const attributes = {
          notes: notes,
          performing_user: performing_user?.username
            ? performing_user?.username
            : "",
        };
        try {
          await onSubmit(attributes, true);
          setToast([
            ...toast,
            {
              message: "Success",
              open: true,
              severity: "success",
            },
          ]);
          // formik.resetForm({
          //   values: payload.attributes,
          // });
        } catch (error) {
          console.log("error", error);
          setToast([
            ...toast,
            {
              message: error.message,
              open: true,
              severity: "error",
            },
          ]);
          formik.setSubmitting(false);
        }
      }
      submit();
    },
  });
  useEffect(() => {
    init();
  }, []);
  // useEffect(() => {}, [formik?.values?.notes]);
  async function init() {
    let orgUsers = await getOrgUsers(orgID);
    setUsers(orgUsers);
    setIsLoading(false);

    let workEventAssignee = Array.from(orgUsers).filter(
      (user) => user.username === rowProp?.performing_user
    );
    formik.setFieldValue("performing_user", workEventAssignee[0] || null);
  }

  const onSubmit = async (attributes, reload) => {
    // console.log("attributes", attributes);
    // eslint-disable-next-line no-async-promise-executor
    return new Promise(async (resolve, reject) => {
      try {
        const payload = await updateWorkItem(
          attributes,
          rowProp?.work_event,
          rowProp?.id,
          orgID
        );
        /* Once the user successfully signs up, update form state to show the confirm sign up form for MFA */
        resolve({ id: payload?.id, attributes });

        dispatch(
          workItemsSlice.actions.updateWorkItemPerformingUser({
            workItemId: rowProp?.id,
            performing_user: attributes?.performing_user,
            notes: attributes?.notes,
            status: "IN_REVIEW",
          })
        );
        if (reload) {
          window.location.reload();
        }
      } catch (error) {
        reject(error);
      }
    });
  };

  return (
    <Stack
      sx={{
        py: 2,
        height: "100%",
        boxSizing: "border-box",
        // background: "rgba(43, 124, 211, 0.08)",
        background: "#fff",
      }}
      direction="column"
    >
      <Paper elevation={0} sx={{ mx: 1, p: 1 }}>
        <Stack direction="column" spacing={1} sx={{ height: 1 }}>
          <form>
            {/* <Grid container>
              <Grid item md={8} xs={12} sx={{ px: 2, mb: 5 }}>
                <Typography variant="h6">{`Work Item #${rowProp?.id}`}</Typography>
              </Grid>
            </Grid> */}
            <Box
              sx={
                {
                  // display: "flex",
                  // alignItems: "flex-end",
                  // height: "100%",
                  // width: "100%",
                }
              }
            >
              <RunProcedure
                rowProp={rowProp}
                orgID={orgID}
                serviceType={rowProp?.service_type}
                serviceOption={rowProp?.service_option}
                mode={mode}
                report={report}
                summaryReason={
                  <>
                    <div>
                      <InputLabel>
                        <Typography fontWeight="700">Summary Reason</Typography>
                      </InputLabel>
                      <TextField
                        autoComplete="off"
                        size="small"
                        disabled={true}
                        error={Boolean(
                          formik.touched.notes && formik.errors.notes
                        )}
                        fullWidth
                        helperText={formik.touched.notes && formik.errors.notes}
                        placeholder="Type"
                        // label="Company or Organization Name"
                        margin="normal"
                        sx={{ mt: 0 }}
                        // disabled={mode === "VIEW"}
                        name="summaryReason"
                        onBlur={formik.handleBlur}
                        onChange={formik.handleChange}
                        value={formik.values.notes}
                        variant="outlined"
                      />
                    </div>
                  </>
                }
                assignee={
                  <>
                    {users.length ? (
                      <div>
                        <InputLabel>
                          <Typography fontWeight="700" variant="subtitle1">
                            Assignee
                          </Typography>
                        </InputLabel>
                        <Autocomplete
                          options={users}
                          size="small"
                          sx={{ mt: 0 }}
                          disabled={rowProp?.status === "COMPLETED"}
                          value={formik.values.performing_user}
                          fullWidth
                          onChange={(_e, value) => {
                            if (value?.username) {
                              formik.setFieldValue("performing_user", value);
                              onSubmit({
                                performing_user: value?.username,
                              });
                            } else {
                              formik.setFieldValue("performing_user", null);
                              onSubmit({
                                performing_user: null,
                              });
                            }
                          }}
                          getOptionLabel={(option) => option.username}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              sx={{ mt: 0 }}
                              variant="outlined"
                              placeholder="Select User"
                              inputProps={{
                                ...params.inputProps,
                              }}
                              name="performingUser"
                              id="performingUser"
                              error={Boolean(
                                formik.touched.performing_user &&
                                  formik.errors.performing_user
                              )}
                              helperText={
                                formik.touched.performing_user &&
                                formik.errors.performing_user
                              }
                              onBlur={formik.handleBlur}
                            />
                          )}
                        />
                      </div>
                    ) : (
                      "No Users Found"
                    )}
                  </>
                }
                notes={
                  <>
                    {" "}
                    <div style={{ width: "100%" }}>
                      {/* <Business position="end" /> */}
                      <InputLabel
                        sx={{ display: "flex", alignItems: "center" }}
                      >
                        <Typography fontWeight="700">Notes</Typography>
                      </InputLabel>

                      <TextField
                        autoComplete="off"
                        size="small"
                        error={Boolean(
                          formik.touched.notes && formik.errors.notes
                        )}
                        fullWidth
                        helperText={formik.touched.notes && formik.errors.notes}
                        placeholder="Type"
                        // label="Company or Organization Name"
                        margin="normal"
                        sx={{ mt: 0 }}
                        disabled={mode === "VIEW"}
                        name="notes"
                        onBlur={formik.handleBlur}
                        onChange={formik.handleChange}
                        value={formik.values.notes}
                        InputProps={{
                          inputComponent: TextareaAutosize,
                          inputProps: { minRows: 4 },
                        }}
                        variant="outlined"
                      />
                    </div>
                  </>
                }
              />
              {isLoading ? "Loading..." : ""}

              {mode !== "INTERACTIVE" ? null : (
                <>
                  <Divider sx={{ py: 1 }} />
                  <Stack
                    direction={{ xs: "column", md: "row" }}
                    justifyContent="flex-end"
                    spacing={{ xs: 1, md: 2 }}
                    sx={{ py: 2 }}
                  >
                    <div>
                      <Button
                        color="secondary"
                        disabled={
                          mode === "VIEW"
                            ? true
                            : !rowProp?.procedure_done
                            ? true
                            : false
                          // !(
                          //   formik.isValid &&
                          //   formik.dirty &&
                          //   !formik.isSubmitting
                          // )
                        }
                        fullWidth
                        size="large"
                        //   type="submit"
                        onClick={(e) => {
                          e.preventDefault();
                          workItemStatusChange(
                            e,
                            rowProp?.work_event,
                            rowProp?.id,
                            "IN_REVIEW",
                            true
                          );
                          formik.handleSubmit(e);
                        }}
                        variant="contained"
                      >
                        Done
                      </Button>
                    </div>
                  </Stack>
                </>
              )}
            </Box>
          </form>
          {toast.map((item, id) => {
            return (
              <Snackbar
                key={id}
                open={item.open}
                autoHideDuration={6000}
                onClose={() => {
                  setToast(toast.filter((v, i) => i !== id));
                }}
              >
                <Alert
                  onClose={() => {
                    setToast(toast.filter((v, i) => i !== id));
                  }}
                  severity={item.severity}
                  sx={{ width: "100%" }}
                  variant="filled"
                >
                  {item.message}
                </Alert>
              </Snackbar>
            );
          })}
        </Stack>
      </Paper>
    </Stack>
  );
};

WorkItem.propTypes = {
  row: PropTypes.object.isRequired,
};

export { WorkItem };
